import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { feedViewerContext } from '../utils/searchFeedReturn';
import { APP_ROUTES } from '../utils/constant';
import url from '../utils/url';
import { createFeedStoryPreview } from '../utils/feedStoryPreview';

// Event filters belong to this history entry, independently of the main feed.
export default function useStoryFilters(storyId, mode) {
  const location = useLocation();
  const navigate = useNavigate();
  const parameters = new URLSearchParams(location.search);
  const area = ['country', 'friends'].includes(parameters.get('area')) ? parameters.get('area') : 'all';
  const query = mode === 'opinions' ? parameters.get('q') || '' : '';
  const searchOpen = mode === 'opinions' && (parameters.get('search') === '1' || Boolean(query));
  const [composing, setComposing] = useState(false);
  const update = values => {
    const next = new URLSearchParams(location.search);
    Object.entries(values).forEach(([key, value]) => value ? next.set(key, value) : next.delete(key));
    navigate({ pathname: location.pathname, search: next.toString() }, { replace: true, state: location.state });
  };
  const onBack = (story) => {
    const origin = location.state?.storyFeedReturn;
    if (origin?.entry === 'unsubscribe' && Number(origin.storyId) === storyId) {
      navigate(url('/unsubscribe'), { replace: true, state: origin.state });
      return;
    }
    const sameStory = Number(origin?.storyId) === storyId && Number.isSafeInteger(origin?.reactionId) && origin.reactionId > 0;
    navigate(url(sameStory ? `${APP_ROUTES.REACTION}/${origin.reactionId}` : APP_ROUTES.MAIN), {
      replace: true,
      state: sameStory ? { ...origin.state,
        feedStoryPreview: createFeedStoryPreview(origin.reactionId, story, origin.state?.feedRefresh ?? null) } : null,
    });
  };
  return {
    area, query, searchOpen, composing, viewerKey: feedViewerContext(), onBack,
    onAreaChange: next => update({ area: next === 'all' ? null : next }),
    onSearchOpen: () => update({ search: '1' }),
    onSearchClose: () => update({ q: null, search: null }),
    onQueryChange: next => update({ q: next, search: '1' }),
    onCompositionChange: setComposing,
  };
}
